import React, { useMemo } from 'react'
import MoneyConnectHeader from 'containers/App/MoneyConnectHeader'
import Portal from '..'
import classNames from 'classnames';
import AnimatedPopup from './AnimatedPopup';

function PageOverPortal({ className, children, showHeader = true, containerStyles, animated = false }) {
  const styles = useMemo(() => ({ ...containerStyledDefault, ...containerStyles }), [containerStyles]);

  const realContent = (
    <>
      {showHeader ? <MoneyConnectHeader /> : null}
      {children}
    </>
  )

  const content = animated
    ? (
      <AnimatedPopup>
        {realContent}
      </AnimatedPopup>
    )
    : realContent;

  return (
    <Portal
      portalClass={classNames("page-over-portal position-fixed top-0 start-0 w-100", className)}
      styles={styles}
    >
      {content}
    </Portal>
  )
}

export default PageOverPortal;
export { default as AnimatedPopup } from './AnimatedPopup';

const containerStyledDefault = { zIndex: 999, background: "#f0f2f5" };
